module.exports = __webpack_public_path__ + "assets/img/vrkc_dt.8f90e1ec.png";